import React from 'react';
import WhyChooseUsCel from '../WhyChooseUsCel';
import WhyChooseUsRoyal from '../WhyChooseUsRoyal';
import { BRAND } from '../../utils/constants';
import getBrand from '../../utils/getBrand';

const WhyChooseUsUnified = () => {
  const isCelebrity = getBrand()?.id === BRAND.CELEBRITY;

  return isCelebrity ? <WhyChooseUsCel /> : <WhyChooseUsRoyal />;
};

export default WhyChooseUsUnified;
